import React, { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "", redirect: false };
  }

  componentDidCatch(error, info) {
   
    this.setState({ hasError: true, message: error.toString() });
  }

  refresh() {
    this.setState({ hasError: false, message: "" });
  }

  redirectTo() {
    this.setState({ redirect: true, hasError: false, message: "" });
  }

  render() {
    if(this.state.redirect) {
    }
    else if (this.state.hasError) {
      return (
        <Error message={this.state.message} refresh={this.refresh.bind(this)} redirectTo={this.redirectTo.bind(this)} />
      );
    } else {
      return this.props.children;
    }
  }
}

export default class Error extends Component {
  constructor(props) {
    super(props);

    this.state = { redirect: false };
  }

  refresh() {
    this.props.refresh();
  }

  redirectTo() {
    this.props.redirectTo();
  }

  render() {

    return (
      <div style={{ textAlign: "Center", paddingTop: "80px" }}>
        <h4>很抱歉，您访问的界面发生问题</h4>
        <h5>{this.props.message}</h5>
        <p>
        </p>
      </div>
    );
  }
}
